module.exports = __webpack_public_path__ + "img/2-insurance-zone-menu.f72656a4.jpg";